import { useState, useEffect }  from 'react';
import {
    WelcomeMessage,
    ProductList,
    AllProducts,
}                               from './components'
import AuthorizationContext     from 'auth/keycloak-instance';
import loadingAnimationData     from 'app/common/constants/loading.json';
import Lottie 				    from 'react-lottie';

const ProductSelection = _props => {

    const [ showLoading, setShowLoading ]   = useState(false);

    useEffect(() => {
        setShowLoading(false);
    }, [])

    useEffect(() => {
        const handlePageShow = event => {
            if (event.persisted) {
                setShowLoading(false);
            }
        };
    
        window.addEventListener('pageshow', handlePageShow);

        return () => {
            window.removeEventListener('pageshow', handlePageShow);
        };
    }, []);

    const toggleApplicationLoader = url => {
        setShowLoading(false);
        window.location.href = url;
    }

    const renderProductListContent = () => {
        return (
            AuthorizationContext.user.authorizedProducts.length
                ?   <ProductList toggleApplicationLoader={ (url) => toggleApplicationLoader(url) } />
                :   <AllProducts toggleApplicationLoader={ (url) => toggleApplicationLoader(url) } />
        )
    } 

    return (
        <>
            {
                showLoading
                    ?   <div id="application-loader">
                            <div className="spinner-container">
                                <Lottie 
                                    options	= {{ 
                                        loop			: true,
                                        autoplay		: true,
                                        animationData	: loadingAnimationData,
                                        rendererSettings: {
                                        preserveAspectRatio	: "xMidYMid slice"
                                        }
                                    }}
                                    height	= { 80 }
                                    width	= { 80 }
                                />		
                            </div>
                        </div>
                    :   null
            }            
            <WelcomeMessage />
            { renderProductListContent() }
        </>
    )
}

export default ProductSelection